/**
 * @voltxampere/web — SPICE sample netlists (Sprint 16)
 *
 * Reference netlists used by the import dialog's "load sample"
 * sub-menu and by Sprint 17's preset switcher. Each sample is
 * canonical Berkeley SPICE3 — no LTspice extensions, no .options.
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */

export const SPICE_SAMPLES = {
  voltageDivider: `* Voltage divider (5V → 2.5V)
V1 vcc 0 5
R1 vcc out 1k
R2 out 0 1k
.end`,

  rcLowPass: `* RC low-pass filter
V1 in 0 SIN(0 1 1k 0 0)
R1 in out 1k
C1 out 0 100n
.end`,

  rcHighPass: `* RC high-pass filter
V1 in 0 SIN(0 1 1k 0 0)
C1 in out 100n
R1 out 0 1k
.end`,

  bjtAmplifier: `* BJT common-emitter amplifier
V1 vcc 0 12
V2 in 0 SIN(0 0.01 1k 0 0)
R1 vcc collector 4.7k
R2 base 0 10k
R3 vcc base 47k
RE emitter 0 1k
CE emitter 0 100u
Q1 collector base emitter NPN_2N3904
.end`,

  diodeRectifier: `* Half-wave rectifier
V1 ac 0 SIN(0 5 50 0 0)
D1 ac out 1N4148
R1 out 0 10k
C1 out 0 100u
.end`,

  ledDriver: `* LED current limiter
V1 vcc 0 5
R1 vcc anode 220
D1 anode 0 LEDR
.end`,
} as const;

export type SpiceSampleKey = keyof typeof SPICE_SAMPLES;
